import axios from "axios";

export default {
    validateCode(code, professionalId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/domainEmail/code/" +
                code +
                "/professional/" +
                professionalId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createCode(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/domainEmail/code",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    create(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/domainEmail",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    get(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/domainEmail/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllPagination(currentPage = 0, pageSize = 10) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/domainEmails/pagination?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
